import { FC, useEffect, useState, useMemo } from 'react';
import { ModuleDetailsType } from '../../type';
import JNPInfo from './components/JNPInfo';
import NormalInfo from './components/NormalInfo';
import { formDataComsToTiled, parseValueCatch } from '@/common/components/business/DynamicComponent/config';
import { isArray, isNotEmptyAny } from '@lhb/func';
import { JNPIdentification } from '@/common/components/business/DynamicComponent/components/CalculationJNP/ts-config';

// import Surround from '@/common/components/business/StoreDetail/components/Surround';


/** 核心信息组件传参类型 */
interface CoreInfomationProps {
  data: ModuleDetailsType;
  detail?
  detailInfoConfig?;
}

/** 机会点详情-核心信息模块 */
const CoreInfomation: FC<CoreInfomationProps> = ({ data, detail, detailInfoConfig = { span: 12 } }) => {

  const [jnpObject, setJnpObject] = useState<any>({}); // 盈亏测算json转化后的完整对象

  const allFields = useMemo(() => {
    if (!isNotEmptyAny(detail)) return null;

    const { moduleDetails } = detail;
    const module = isArray(moduleDetails) ? moduleDetails.find((itm: any) => itm.moduleType === 4) : null;
    if (!module || !isNotEmptyAny(module.infoModule)) return null;
    const { propertyGroupVOList } = module.infoModule;
    if (!isArray(propertyGroupVOList) || !propertyGroupVOList.length) return null;

    const allComs: any = [];
    formDataComsToTiled(propertyGroupVOList, allComs); // 将组件对象平铺到数组中
    return allComs;
  }, [detail]);

  useEffect(() => {
    const property = allFields?.find(itm => itm.identification === JNPIdentification);
    if (!property) {
      setJnpObject({});
      return;
    }
    const obj = parseValueCatch(property); // textValue的json转为object
    setJnpObject(obj || {});
  }, [detail]);

  return (
    <>
      { isNotEmptyAny(jnpObject)
      /* 基诺浦测算信息（为了封装业务逻辑，在组件内部判断是否展示） */
        ? <JNPInfo allFields={allFields} jnpObject={jnpObject}/>
      /* 普通租户基本信息 */
        : <NormalInfo data={data} detailInfoConfig={detailInfoConfig}/>
      }
    </>
  );
};

export default CoreInfomation;
